export default {
  data() {
    return {
      inputType: 'date-input',
      inputTypeDef: {}
    }
  },
  methods: {

  }
}
